import * as actiontypes from './actionTypes';
import AvailabilityApi from '../api/AvailabilityApi';

export function availability(response) {
    return { type: actiontypes.AVAILABILITY_SUCCESS, response };
}

export function getAvailability(data, apiName) {
    return function (dispatch) {
        const elementId = "shopping-location-json";

        if (data === null || data.merchProductSets == undefined || !data.merchProductSets.some((productSet) => (productSet.productSetItems && productSet.productSetItems.length > 0))) {
            return Promise.reject("Bad Request no Product Data");
        }

        let shoppingLocation = {};
        const shoppingLocationJsonElement = document.getElementById(elementId);

        if (shoppingLocationJsonElement && shoppingLocationJsonElement.innerText) {
            shoppingLocation = JSON.parse(shoppingLocationJsonElement.innerText);
        }
        else {
            return Promise.reject("Bad Request missing data");
        }

        const dlvMode = shoppingLocation.dlvMode || shoppingLocation.dlvModeId;

        if (!dlvMode) {
            return Promise.reject("Bad Request missing dlvMode");
        }

        const altAddressRecId = shoppingLocation.mbsAltAddressRecId || shoppingLocation.displayId;

        let requestUrl = `ProductAvailability/Items_v2?dlvMode=${dlvMode}&version=${apiName || ""}&altAddressRecId=${altAddressRecId || ""}&state=${shoppingLocation.state || ""}&zipCode=${shoppingLocation.zipCode || ""}`;

        let items = [];

        data.merchProductSets.forEach((productSet) => {
            productSet.productSetItems.forEach((item) => {
                items.push({
                    unitId: item.unitId,
                    itemId: item.itemId
                });
            });
        });

        return AvailabilityApi.getAvailability(requestUrl, items).then(response => {
            dispatch(availability(response));
        }).catch(error => {
            throw error;
        });
    }
}